import $ from 'jquery';

const lifecovercards = {
    variable:{
        url: window.location.href,
    },
    methods: {
        viewPlanButtonClickHandler: function () {
            $(document).on('click', '.lifeCoverCards__section__card--button', function() {
                const title = $(".lifeCoverCards__section__heading").text().replace(/\n/g, '').trim();
                const buttonText = $(this).text().replace(/\n/g, '').trim();
                const obj = lifecovercards.methods.dataLayerObj(title, buttonText);
                createDataLayer('buttonClick', obj);
            });
        },

        dataLayerObj : function(el,e) {
                            var obj = {
                                'articleName' : "",
                                'blogCategory' : "",
                                'blogPageCategory' : "",
                                'buttonText' : e ? e : "",
                                'pageSection' : el ? el : "",
                                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? lifecovercards.variable.url.includes("blog") ? "Blogs" : lifecovercards.variable.url.substring(lifecovercards.variable.url.indexOf(".com/"), lifecovercards.variable.url.lastIndexOf('/')  === ".com") && !lifecovercards.variable.url.substring(lifecovercards.variable.url.indexOf(".com/"), lifecovercards.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                                'planOption' : "",
                                'productCategory' : "",
                                'productName' : "",
                                'question' : "",
                                'searchTerm' : "",
                                'videoTitle' : "",
                                'bannerName' : "",
                                'bannerType' : ""

                            };
                            return obj;
                        }
        }
};

$(document).ready(function () {
    lifecovercards.methods.viewPlanButtonClickHandler();
});
